import { render } from "./OrdenAtenciones.vue?vue&type=template&id=565e6102&scoped=true"
import script from "./OrdenAtenciones.vue?vue&type=script&lang=js"
export * from "./OrdenAtenciones.vue?vue&type=script&lang=js"

import "./OrdenAtenciones.vue?vue&type=style&index=0&id=565e6102&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565e6102"]])

export default __exports__